import React from 'react';
import styled from 'styled-components';
import { useTheme } from '@mui/material/styles';

const Loader = ({ fullscreen = true }) => {
  const theme = useTheme();
  return (
    <StyledWrapper theme={theme} $fullscreen={fullscreen}>
      <div className="loader">
        <div style={{ '--i': 0 }} className="bar1" />
        <div style={{ '--i': 1 }} className="bar2" />
        <div style={{ '--i': 2 }} className="bar3" />
        {/* <div style={{ '--i': 3 }} className="bar" />
        <div style={{ '--i': 4 }} className="bar" /> */}
      </div>
    </StyledWrapper>
  );
}

const StyledWrapper = styled.div(({ theme, $fullscreen }) => ({
  position: $fullscreen ? 'fixed' : 'relative',
  inset: $fullscreen ? 0 : 'auto',
  minHeight: $fullscreen ? 'auto' : '140px',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: $fullscreen ? 'rgba(255, 255, 255, 0.6)' : 'transparent',
  zIndex: $fullscreen ? 9999 : 'auto',
  '.loader': {
    display: 'flex',
    gap: '0.8rem',
  },
  '.bar1': {
    '--fill-color': '#70a06a',
    '--shadow-color': 'rgba(0, 0, 0, 0.1)',
    width: '25px',
    height: '25px',
    background: '#e0e0e0',
    overflow: 'hidden',
    borderRadius: '50%',
    position: 'relative',
    boxShadow: '0 0 10px -0.5px var(--shadow-color)',
  },
  '.bar1::after': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    height: 0,
    background: 'var(--fill-color)',
    animation: 'fill 1.2s ease-in-out infinite',
    animationDelay: 'calc(var(--i) * 0.1s)',
  },
  '.bar2': {
    '--fill-color': '#60895b',
    '--shadow-color': 'rgba(0, 0, 0, 0.1)',
    width: '25px',
    height: '25px',
    background: '#e0e0e0',
    overflow: 'hidden',
    borderRadius: '50%',
    position: 'relative',
    boxShadow: '0 0 10px -0.5px var(--shadow-color)',
  },
  '.bar2::after': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    height: 0,
    background: 'var(--fill-color)',
    animation: 'fill 1.2s ease-in-out infinite',
    animationDelay: 'calc(var(--i) * 0.1s)',
  },
  '.bar3': {
    '--fill-color': '#50724c',
    '--shadow-color': 'rgba(0, 0, 0, 0.1)',
    width: '25px',
    height: '25px',
    background: '#e0e0e0',
    overflow: 'hidden',
    borderRadius: '50%',
    position: 'relative',
    boxShadow: '0 0 10px -0.5px var(--shadow-color)',
  },
  '.bar3::after': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    height: 0,
    background: 'var(--fill-color)',
    animation: 'fill 1.2s ease-in-out infinite',
    animationDelay: 'calc(var(--i) * 0.1s)',
  },
  '@keyframes fill': {
    '0%': { height: 0 },
    '100%': { height: '100%' },
  },
}));

export default Loader;
